export default "__VITE_ASSET__7fa0b9af__"